module.exports = __webpack_public_path__ + "media/images/sales/nanairoweek/heading-mv-7d4bf568c384afd88af13aa0f5be7ac7.png";